import React, { useContext } from "react";

import classNames from "classnames";
import { observer } from "mobx-react";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";
import PhotoRow from "./PhotoRow";

const Container = styled.div`
  ${(props) => props.dynamicStyles || ""}
`;

function AnimatedCards() {
  const { wrapperClassName, CSS, fullWidth } = useContext(ComponentContext);

  const rowClassName = classNames(
    { row: !fullWidth },
    wrapperClassName,
    "animated-cards"
  );

  return (
    <Container className={rowClassName} dynamicStyles={CSS}>
      <PhotoRow />
    </Container>
  );
}

export default observer(AnimatedCards);
